// extracted by mini-css-extract-plugin
module.exports = {"holder":"AppLayoutWrapFull_holder__3tMoi","content":"AppLayoutWrapFull_content__2Dliu"};